import { render, staticRenderFns } from "./MsgList.vue?vue&type=template&id=605d3c7a&scoped=true"
import script from "./MsgList.vue?vue&type=script&lang=js"
export * from "./MsgList.vue?vue&type=script&lang=js"
import style0 from "./MsgList.vue?vue&type=style&index=0&id=605d3c7a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_d02125917f7c66a571cdcbfa3dd68341/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605d3c7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('605d3c7a')) {
      api.createRecord('605d3c7a', component.options)
    } else {
      api.reload('605d3c7a', component.options)
    }
    module.hot.accept("./MsgList.vue?vue&type=template&id=605d3c7a&scoped=true", function () {
      api.rerender('605d3c7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/consult/components/MsgList.vue"
export default component.exports